import AbstractGuestlistDetailsPageController from '../guestlists/abstract-details-controller';
import editorTemplate from '../../../views/rsvps-multiple-editor.html'

export default class GuestlistRsvpsListPageController extends AbstractGuestlistDetailsPageController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.alert = this.injector.get('Alert');
        this.contactObj = this.injector.get('Contact');
        this.depositService = this.injector.get('Deposit');
        this.rsvpsBaseStore = this.injector.get('Rsvps');
        this.modal = this.injector.get('$uibModal');
        this.transitions = this.injector.get('$transitions');

        this.navService = this.injector.get('NavService');

        this.deposits = {
            countries: {},
            languages: {},
            genders: {},
            states: {}
        };

        this.availableGuestlistObjects = [];
        this.currentGuestlistObject = null;
        this.store = null;
        this.mode = 'listview';
        this.deposits = {
            countries: {},
            languages: {},
            genders: {},
            states: {}
        };

        this._loadDeposits();
    }

    _loadDeposits() {
        this.depositService.getRemoteDeposit('contacts', 'countries', []).then((value) => {
            this.deposits.countries = value;
        });
        this.depositService.getRemoteDeposit('contacts', 'languages', []).then((value) => {
            this.deposits.languages = value;
        });
        this.depositService.getRemoteDeposit('contacts', 'genders', []).then((value) => {
            this.deposits.genders = value;
        });
        this.depositService.getRemoteDeposit('rsvps', 'states', []).then((value) => {
            this.deposits.states = value;
        });
    }

    _handleGuestlistSelect() {
        super._handleGuestlistSelect();
        this._setupStore();
    }

    _setupStore() {
        if (this.stateParams.store) {
            this.store = this.stateParams.store;
        } else {
            this.store = this.rsvpsBaseStore.create('GuestlistView');
            if (this.store.state.visible.length <= 3) {
                this.store.commit('setVisible', [
                    'contact.full_name',
                    'status',
                    'pax_planned',
                    'pax_guest',
                    'code',
                    'contact.sex',
                    'contact.first_name',
                    'contact.last_name',
                    'contact.email',
                    'last_message_state',
                    'created_at',
                    'updated_at'
                ]);
            }
        }

        this.store.commit('addAction', {
            key: 'download-files',
            title: 'Download files',
            level: 'selected',
            order: 41,
            action: function () {
                this.downloadFiles();
            }.bind(this)
        });
        this.store.commit('setTitle', this.guestlist.name);
        this.store.commit('setPermanentFilters', {'guestlist_id': this.guestlist.id});
        this.store.commit('setVm', this);

        this.store.dispatch('loadWorkflows', 'rsvps::list');

        if (_.get(this.injector.get('Users'), 'state.company.settings.rsvps.reduced_quick_edit_guest')) {
            this.store.commit('setEmptyListActions', [
                'quick-add-guest-custom',
                'import-rsvps'
            ])
        } else {
            this.store.commit('setEmptyListActions', [
                'quick-add-contact',
                'import-rsvps'
            ]);
        }

        this.store.commit('setVm', this);
        this.store.commit('setPrefix', 'guestlists/' + this.guestlist.id);
        this.store.commit(
            'setConfiguredFields',
            _.map(
                _.get(this.guestlist, 'settings.enabled_fields'),
                (field) => {
                    return _.startsWith(field, 'rsvp.') ? field.replace('rsvp.', '') : field;
                }
            )
        );
        this.store.resetGetters();
    }

    showMultipleEditor() {
        this.mode = 'editor';
        this.editorTemplate = editorTemplate;
        this.parentSelector = {
            store: _.cloneDeep(this.store).reset({
                persist: false,
                permanentFilters: {'guestlist.id': this.guestlist.id}
            }),
            displayField: 'contact.full_name'
        };
        this.rsvp = {};
        this.contact = {};
        this.contactObj.getSchema().then(schema => {
            this.schema = schema;
        });

        this.customFields = _(this.guestlist)
            .map((value, attr) => {
                if (attr.match(/custom_\d*_name/gi) && _.keys(value).length) {
                    value.key = attr.match(/custom_\d*/gi)[0];
                    return value;
                }
            })
            .filter()
            .value();
    }

    close() {
        this.mode = 'listview';
        this.scope.$applyAsync();
        if (this.store) {
            this.store.dispatch('getData');
        }
    }

    save() {
        const data = {
            fields: {rsvp: this.rsvp, contact: this.contact},
            items: this.store.getters.selectedFilters
        };
        this.api.put(`rsvps`, data)
            .then(() => {
                this.alert.success('Bookings Update', 'The bookings details have successfully been updated');
                this.mode = 'listview';
                this.scope.$applyAsync();
                if (this.store) {
                    this.store.dispatch('getData');
                }
            }, err => this.alert.handle(err));

    }

}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/rsvps/list-controller.js